import { useFormik } from 'formik';
import { PqrReceptionChannelParamsDataProps } from './props';
import { useEffect } from 'react';

export const usePqrReceptionChannelData = ({
    data,
}: PqrReceptionChannelParamsDataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra', data?.extra || '');
    }, [data]);

    return {
        formik,
    };
};
